export enum eFetchSpecifier {
    Children = "children",
    Ancestors = "ancestors",
    Descendants = "descendants"
}
